export const LISTBOX_OTHER_OPTION_ID = '_other_';
